export const Home = () => (
    <div>Sing Your Part Billing</div>
);
